import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { isEmpty, formatMoney } from '../../utils/helpers/helpers';
import { routes } from '../../utils/constants/constant';
import BreadCrumbComponent from '../../components/breadcrumb/BreadCrumbComponent';
import { Tabs, Table } from 'antd';

import './Help.scss';
import { connect } from 'react-redux';
import Policy from './Policy';

const breadCrumbs = [
  {
    name: 'Trang chủ',
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: 'Hỗ trợ',
    isLink: false,
  },
];
const { TabPane } = Tabs;
const columns = [
  {
    title: 'Mức',
    dataIndex: 'level',
    key: 'level',
  },
  {
    title: 'Doanh thu một tháng',
    key: 'revenue',
    render: (text, record) => {
      return (
        <>{` Từ ${formatMoney(record.gmvfrom)} đ đến${
          !isEmpty(record.gmvto) ? ` ${formatMoney(record.gmvto)}đ` : ' trở lên'
        }`}</>
      );
    },
  },
  {
    title: 'Hoa hồng khách sạn',
    key: 'commission',
    align: 'center',
    render: (text, record) => {
      const hotel =
        record?.affiliationCommissions.find((el) => el.module === 'hotel') ||
        {};

      return <>{`${hotel.percent}%`}</>;
    },
  },
  {
    title: 'Hoa hồng vé máy bay',
    key: 'commissionFly',
    align: 'center',
    render: (text, record) => {
      const flight =
        record?.affiliationCommissions.find((el) => el.module === 'flight') ||
        {};
      return <>{`${formatMoney(flight.fixedAmount)}đ/vé người lớn`}</>;
    },
  },
  // {
  //   title: 'Hoa hồng hàng tiêu dùng',
  //   key: 'commissionGrocery',
  //   align: 'center',
  //   render: (text, record) => {
  //     const hotel =
  //       record?.affiliationCommissions.find((el) => el.module === 'grocery') ||
  //       {};

  //     return <>{`${hotel.percent}%`}</>;
  //   },
  // },
];
const dataSourceRevenue = [
  {
    condition: 'Điều kiện 1',
    level_condition:
      'Khách Hàng sử dụng Mã Khuyến Mại mà VNTRAVEL cung cấp cho Đối Tác Liên Kết thông qua Hệ Thống Quản Lý để thực hiện việc đặt Sản Phẩm.  HOẶC  Khách Hàng sử dụng Đường Dẫn của Đối Tác Liên Kết để đặt Sản Phẩm trên nền tảng website, mobile website.',
  },
  {
    condition: 'Điều kiện 2',
    level_condition:
      'Đơn phòng thanh toán thành công và khách hàng đã trả phòng (check-out)',
  },
];

const columnsRevenue = [
  {
    dataIndex: 'condition',
  },
  {
    dataIndex: 'level_condition',
  },
];

const dataSourceViolate = [
  {
    condition: 'Vi phạm lần đầu tiên',
    level_condition:
      '50% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm.',
  },
  {
    condition: 'Vi phạm lần thứ hai',
    level_condition:
      '100% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm.',
  },
  {
    condition: 'Vi phạm lần thứ ba',
    level_condition:
      '100% Hoa Hồng của tất cả các Đơn Đặt Hàng Thành Công phát sinh trong tháng có vi phạm. Đồng thời, VNTRAVEL sẽ khóa Tài Khoản Liên Kết và chấm dứt hợp tác với Đối Tác Liên Kết.',
  },
];

const columnsViolate = [
  {
    title: 'Vi phạm',
    dataIndex: 'condition',
  },
  {
    title: 'Mức phạt vi phạm và bồi thường thiệt hại',
    dataIndex: 'level_condition',
  },
];

const Help = (props) => {
  const [activeTab, setActiveTab] = useState(
    queryString.parse(props?.location?.search)?.tab === 'dieu-kien-dieu-khoan'
      ? '2'
      : '1'
  );
  useEffect(() => {
    const location = props?.location || {};
    if (!isEmpty(location.search)) {
      const search = location.search;
      const params = new URLSearchParams(search);
      const commission = params.get('commission');
      if (!isEmpty(commission)) {
        setActiveTab('3');
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className='container-hep'>
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className='title-container-hep'>Hỗ trợ</div>
      <Tabs
        activeKey={activeTab}
        onChange={(activeTab) => setActiveTab(activeTab)}
      >
        <TabPane tab='FAQs' key='1'>
          <Tabs defaultActiveKey='1' tabPosition='left' className='tab-child'>
            <TabPane tab='Tổng quan' key='1'>
              <div>
                <span
                  style={{
                    fontSize: 16,
                    lineHeight: '19px',
                    fontWeight: 600,
                    color: '#1A202C',
                  }}
                >
                  Vì sao tôi nên tham gia Chương trình Đối tác Liên kết
                  (Affiliate) của Mytour?
                </span>
                <div className='wrap-payment'>
                  Kết nối với hơn 20.000 nhà cung cấp về vé máy bay, phòng khách
                  sạn, và các sản phẩm du lịch khác, Chương trình Đối tác Liên
                  kết của Mytour là một trong những chương trình tiên phong của
                  loại hình này tại thị trường du lịch Việt Nam. Các sản phẩm
                  của chúng tôi phong phú về nguồn hàng, có mức giá cạnh tranh,
                  đảm bảo tỷ lệ chuyển đổi cao và đem về cho đối tác mức hoa
                  hồng hấp dẫn. Mọi tính năng trong Chương trình Đối tác Liên
                  kết từ đăng ký tài khoản, ký hợp đồng điện tử, hỗ trợ trực
                  tuyến, đến thanh toán hoa hồng đều được tối ưu tự động, nhanh
                  chóng để đảm bảo các đối tác có thể dễ dàng tiếp cận và sử
                  dụng dễ dàng.
                </div>
              </div>

              <div style={{ marginTop: 40 }}>
                <span
                  style={{
                    fontSize: 16,
                    lineHeight: '19px',
                    fontWeight: 600,
                    color: '#1A202C',
                  }}
                >
                  Ai có thể tham gia Chương trình Đối tác Liên kết?
                </span>
                <div className='wrap-payment'>
                  Bạn có muốn mang đến cho người theo dõi của mình những ưu đãi
                  tuyệt vời và đồng thời kiếm thêm thu nhập? Mytour luôn quan
                  tâm đến việc xây dựng quan hệ đối tác với các Blogger và Kols
                  để cùng chia sẻ đam mê đối với du lịch và trải nghiệm.
                </div>
              </div>
              <div style={{ marginTop: 40 }}>
                <span
                  style={{
                    fontSize: 16,
                    lineHeight: '19px',
                    fontWeight: 600,
                    color: '#1A202C',
                  }}
                >
                  Tôi có thể trở thành một Đối tác Liên kết khi không có
                  website/trang mạng xã hội, hay có nhiều website/trang mạng xã
                  hội hay không?
                </span>
                <div className='wrap-payment'>
                  Mytour mong muốn hợp tác chia sẻ lợi nhuận từ các sản phẩm du
                  lịch với các đối tác từ tất cả các ngành nghề, lĩnh vực, và
                  hoạt động trên tất cả các nền tảng. Bạn có thể chia sẻ link
                  sản phẩm và mã giảm giá trên một hoặc nhiều website, trang
                  mạng xã hội, hoặc qua bất kỳ hình thức nào để tiếp cận đến
                  khách hàng.
                </div>
              </div>
              <div style={{ marginTop: 40 }}>
                <span
                  style={{
                    fontSize: 16,
                    lineHeight: '19px',
                    fontWeight: 600,
                    color: '#1A202C',
                  }}
                >
                  Tôi có thể đổi thông tin cá nhân của mình sau khi đăng ký
                  không?
                </span>
                <div className='wrap-payment'>
                  Bạn có thể thay đổi hầu hết các thông tin cá nhân của mình bất
                  kỳ lúc nào trong mục Tài khoản của tôi. Tuy nhiên, xin lưu ý
                  Địa chỉ Email dùng để đăng nhập sẽ không thể đổi được. Vì vậy,
                  hãy kiểm tra kỹ thông tin email khi đăng ký tài khoản.
                </div>
              </div>
              <div style={{ marginTop: 40 }}>
                <span
                  style={{
                    fontSize: 16,
                    lineHeight: '19px',
                    fontWeight: 600,
                    color: '#1A202C',
                  }}
                >
                  Làm sao để tăng thêm thu nhập với Chương trình Đối tác Liên
                  kết của Mytour?
                </span>
                <div className='wrap-payment'>
                  Khi là Đối tác Liên kết của Mytour, chúng tôi sẽ thanh toán
                  cho bạn khoản hoa hồng bạn tích lũy được dựa trên giá trị các
                  đơn hàng (vé máy bay, phòng khách sạn) được đặt thành công và
                  tỷ lệ chiết khấu. Bạn có thể theo dõi thu nhập của mình khi
                  đăng nhập tài khoản trên website Mytour.vn.
                </div>
              </div>
            </TabPane>
            <TabPane tab='Quy định về ghi nhận doanh thu' key='2'>
              <div className='wrap-amount'>
                <span className='title'>
                  Ghi nhận doanh thu cho publisher khi đáp ứng cả 2 điều kiện
                  sau:
                </span>
                <div className='content'>
                  <Table
                    dataSource={dataSourceRevenue}
                    columns={columnsRevenue}
                    pagination={false}
                  />

                  <div className='wrap-cookie'>
                    <p className='cookie'>
                      Các nguyên tắc ghi nhận doanh thu và tính hoa hồng:{' '}
                    </p>
                    <p>
                      - Nguyên tắc ưu tiên Đường Dẫn: <br />
                      Nếu Khách Hàng sử dụng Mã Khuyến Mại của một Đối Tác Liên
                      Kết, nhưng thực hiện Đơn Đặt Hàng thông qua Đường Dẫn của
                      một Đối Tác Liên Kết khác, thì Đơn Đặt Hàng Thành Công sẽ
                      được ghi nhận là Doanh Thu của Đối Tác Liên Kết mà Khách
                      Hàng đã sử dụng Đường Dẫn.
                    </p>
                    <p>
                      - Nguyên tắc nhấp chuột cuối cùng (last click) <br />
                      Nếu Khách Hàng nhấp chuột (click) vào nhiều Đường Dẫn/
                      Trang Web Liên Kết của các Đối Tác Liên Kết khác nhau thì
                      VNTRAVEL sẽ ghi nhận Doanh Thu và tính Hoa Hồng cho Đối
                      Tác Liên Kết mà Khách Hàng đã truy cập Đường Dẫn/ Trang
                      Web Liên Kết lần cuối cùng trước khi có Đơn Đặt Hàng.
                    </p>
                    <p>
                      - Nguyên tắc Thời Gian Lưu Cookie 30 ngày. <br />
                      Bất kỳ Đơn Đặt Hàng nào của Khách Hàng được đặt thông qua
                      Đường Dẫn/ Trang Web Liên Kết của Đối Tác Liên Kết trong
                      vòng 30 ngày kể từ ngày cuối cùng Khách Hàng nhấp chuột
                      (click) vào Đường Dẫn/ Trang Web Liên Kết của Đối Tác Liên
                      Kết, đều được ghi nhận là Doanh Thu và là căn cứ để tính
                      Hoa Hồng cho Đối Tác Liên Kết.
                    </p>
                    <p>
                      - Nguyên tắc chỉ thanh toán Hoa Hồng cho các Tài Khoản
                      Liên Kết Đã Xác Thực. <br />
                      VNTRAVEL chỉ thanh toán Hoa Hồng cho các Tài Khoản Liên
                      Kết Đã Xác Thực tại thời điểm thanh toán. Trong trường
                      hợp, Tài Khoản Liên Kết chưa được xác thực tại thời điểm
                      thanh toán và/hoặc chưa đáp ứng Điều Kiện Tham Gia để được
                      xác thực tại thời điểm thanh toán, thì Hoa Hồng sẽ được
                      tích lũy trong vòng 03 (ba) tháng kể từ ngày Đối Tác Liên
                      Kết đăng ký Tài Khoản Liên Kết. Quá thời hạn nêu trên, nếu
                      Tài Khoản Liên Kết không đáp ứng Điều Kiện Tham Gia để
                      được xác thực, thì Hoa Hồng đã tích lũy sẽ mất hiệu lực và
                      VNTRAVEL không có trách nhiệm thanh toán khoản Hoa Hồng
                      này.
                    </p>
                  </div>
                  <div className='wrap-traffic'>
                    <span className='traffic'>Quy định về traffic</span>
                    <span>
                      Không chạy từ khóa tên thương hiệu Mytour trên các công cụ
                      tìm kiếm (Google Adwords, Cốc cốc...), lập trang page,
                      group, website mang thương hiệu Mytour. Trong tiêu đề, mô
                      tả, link hiển thị quảng cáo tìm kiếm không được chứa
                      thương hiệu Mytour.
                    </span>

                    <Table
                      dataSource={dataSourceViolate}
                      columns={columnsViolate}
                      pagination={false}
                    />
                  </div>
                </div>
              </div>
            </TabPane>

            <TabPane tab='Quy trình nghiệm thu & thanh toán' key='3'>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: 1.8,
                  color: '#1A202C',
                }}
              >
                3. Quy trình nghiệm thu & thanh toán
              </span>
              <div className='wrap-payment'>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: 1.8,
                    color: '#1A202C',
                  }}
                >
                  Tính Doanh Thu và Hoa Hồng{' '}
                </span>{' '}
                <br />
                VNTRAVEL sẽ tính Doanh Thu và Hoa Hồng mà Đối Tác Liên Kết nhận
                được mỗi tháng. Trong vòng 10 ngày làm việc đầu tiên của tháng
                N+1, VNTRAVEL sẽ gửi Đối Tác Liên Kết kết quả Doanh Thu và Hoa
                Hồng mà Đối Tác Liên Kết nhận được trong tháng N thông qua email
                mà Đối Tác Liên Kết đã cung cấp tại Đơn Đăng Ký và/hoặc thông
                qua Tài Khoản Liên Kết trên Hệ Thống Quản Lý. <br /> Đối Tác
                Liên Kết có trách nhiệm kiểm tra email và Tài Khoản Liên Kết để
                cập nhật kết quả Doanh Thu và Hoa Hồng.
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: 1.8,
                    color: '#1A202C',
                  }}
                >
                  Thanh toán
                </span>{' '}
                <p>
                  - Thời gian thanh toán: VNTRAVEL có trách nhiệm thanh toán Hoa
                  Hồng cho Đối Tác Liên Kết trong vòng 30 ngày kể từ ngày có đầy
                  đủ hồ sơ thanh toán hợp lệ.{' '}
                </p>
                <p>-Hồ sơ thanh toán hợp lệ gồm: </p>
                <p>(i) Với Đối Tác Liên Kết là cá nhân: </p>
                <p>
                  • Thông tin chứng minh nhân dân/ căn cước công dân của người
                  nhận thanh toán.{' '}
                </p>
                <p>
                  • Thông tin tài khoản nhận thanh toán. Để làm rõ, thông tin
                  của chủ tài khoản nhận thanh toán phải trùng khớp với thông
                  tin trên chứng minh nhân dân/căn cước công dân.{' '}
                </p>
                <p>
                  • Các thông tin khác theo yêu cầu của VNTRAVEL trên Hệ Thống
                  Quản Lý mà VNTRAVEL xét thấy cần thiết để thực hiện thanh
                  toán.
                </p>
                <p>(ii) Đối Tác Liên Kết là tổ chức</p>
                <p>
                  • Hóa đơn tài chính hợp lệ của Đối Tác Liên Kết phát hành cho
                  VNTRAVEL.
                </p>
                <p>
                  • Thông tin tài khoản nhận thanh toán. Để làm rõ, chủ tài
                  khoản nhận thanh toán phải là tổ chức phát hành hóa đơn tài
                  chính cho VNTRAVEL.
                </p>
                <p>
                  • Các thông tin khác theo yêu cầu của VNTRAVEL trên Hệ Thống
                  Quản Lý mà VNTRAVEL xét thấy cần thiết để thực hiện thanh
                  toán.
                </p>
              </div>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: 1.8,
                  color: '#1A202C',
                }}
              >
                Hình thức thanh toán
              </span>
              <p>
                - VNTRAVEL sẽ thực hiện chuyển khoản bằng đồng Việt Nam theo
                thông tin tài khoản Đối Tác Liên Kết cập nhật trên Hệ Thống Quản
                Lý. Nếu có thay đổi thông tin nhận thanh toán, Đối Tác Liên Kết
                cần cập nhật các thông tin này trước 00:00:00 ngày 25 hàng tháng
                tháng. VNTRAVEL không chịu trách nhiệm nếu những cập nhật này
                được thực hiện sau thời gian nêu trên.{' '}
              </p>
              <p>
                - Không phụ thuộc vào quy định về thời gian thanh toán nêu trên,
                VNTRAVEL chỉ có trách nhiệm thanh toán Hoa Hồng khi số tiền Hoa
                Hồng tích lũy qua các tháng của Đối Tác Liên Kết đạt mức tối
                thiểu là 50.000 VNĐ (bằng chữ: năm mươi nghìn đồng).{' '}
              </p>
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: 1.8,
                  color: '#1A202C',
                }}
              >
                Thuế
              </span>
              <p>
                - Đối Tác Liên Kết sẽ chịu trách nhiệm thanh toán các khoản Thuế
                (bao gồm những không giới hạn ở thuế thu nhập cá nhân) theo quy
                định của pháp luật liên quan đến thu nhập của Đối Tác Liên Kết
                phát sinh từ việc thực hiện Hợp Đồng này. Đối Tác Liên Kết đồng
                ý miễn trừ VNTRAVEL khỏi bất kỳ trách nhiệm nào liên quan đến
                nghĩa vụ nộp thuế của Đối Tác Liên Kết.{' '}
              </p>
              <p>
                - Trong trường hợp Đối Tác Liên Kết là cá nhân. Đối Tác Liên Kết
                đồng ý để VNTRAVEL cấn trừ thuế thu nhập cá nhân trước khi thực
                hiện thanh toán Hoa Hồng và Đối Tác Liên Kết sẽ cung cấp các
                thông tin cần thiết cho VNTRAVEL để thực hiện việc nộp thuế thu
                nhập cá nhân.{' '}
              </p>
            </TabPane>
          </Tabs>
        </TabPane>
        <TabPane tab='Điều kiện & Điều khoản' key='2'>
          <Policy
            content={
              <Table
                dataSource={props?.generalInfo?.affiliationLevels || []}
                columns={columns}
                pagination={false}
              />
            }
          />
        </TabPane>
        <TabPane tab='Hoa hồng' key='3'>
          <Table
            dataSource={props?.generalInfo?.affiliationLevels || []}
            columns={columns}
            pagination={false}
            rowKey={(item) => item?.level}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default connect(
  (state) => ({
    generalInfo: state.systemReducer.generalInfo,
  }),
  {}
)(withRouter(Help));
